/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getApiSdk } from '@api-sdk';
import {
  VideoRequestAssetCreateResponseSchema,
  VideoRequestPayloadSchema,
} from '@sendspark/js-api-sdk';

export const getVideoRequest = async (
  requestId: string,
  options?: any
): Promise<any> => {
  const response = await getApiSdk.getVideoRequestByRequestId(
    requestId,
    options
  );

  return response.data;
};

interface CreateVideoRequestAssetArgs {
  requestId: string;
  folderId: string;
  mime: string;
  name?: string;
  options?: any;
}

interface CreateVideoRequestAsset {
  (
    args: CreateVideoRequestAssetArgs
  ): Promise<VideoRequestAssetCreateResponseSchema>;
}

export const createVideoRequestAsset: CreateVideoRequestAsset = async ({
  requestId,
  folderId,
  mime,
  options,
  ...rest
}) => {
  const response = await getApiSdk.createVideoRequestAssetByRequestId(
    requestId,
    { folderId, mime, ...rest },
    options
  );

  return response.data;
};

export const updateVideoRequest = async (
  requestId: string,
  payload: Record<string, any>,
  options: any
): Promise<any> => {
  const response = await getApiSdk.putVideoRequestById(
    requestId,
    payload as VideoRequestPayloadSchema,
    options
  );

  return response.data;
};
